import { render, staticRenderFns } from "./faceAdmin.vue?vue&type=template&id=54928b77&scoped=true"
import script from "./faceAdmin.vue?vue&type=script&lang=js"
export * from "./faceAdmin.vue?vue&type=script&lang=js"
import style0 from "./faceAdmin.vue?vue&type=style&index=0&id=54928b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54928b77",
  null
  
)

export default component.exports